import { MESSAGE_TYPE } from '../../constants/MessageTypes';
import AbstractMessageModel from './AbstractMessageModel';

export default class MarkReadMessageModel extends AbstractMessageModel {
  constructor(args = {}) {
    super({ messageType: MESSAGE_TYPE.MARK_READ, ...args });
  }
}
